import styled from 'styled-components';

import { getFontStyle } from '~components/Text/helper';

export const S = {
  StyledBadge: styled.div<{ bgColor: string; fontColor: string }>`
    padding: 1.5px 4px;
    border-radius: 9px;

    color: ${({ fontColor }) => fontColor};
    background-color: ${({ bgColor }) => bgColor};
    ${getFontStyle('midium120_C1')};
  `,
};
